import { render, staticRenderFns } from "./message-recharge.vue?vue&type=template&id=d4bc6876&scoped=true&"
import script from "./message-recharge.vue?vue&type=script&lang=ts&"
export * from "./message-recharge.vue?vue&type=script&lang=ts&"
import style0 from "./message-recharge.vue?vue&type=style&index=0&id=d4bc6876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bc6876",
  null
  
)

export default component.exports